import React, { Fragment, useContext, useEffect, useState } from "react";
import { JobType, JobTypeUserAccessRights } from "src/modules/JobModule/JobState";
import { ADModalBody, ADModalFooter, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { GlassInputControl, GlassInputGroup, GlassInputGroupEscape, GlassInputGroupTitle, GlassTextInputTransformer } from "src/components/GlassInput";
import { GlassButton } from "src/components/GlassButtons";
import { BsXLg } from "react-icons/bs";
import { ApplicationStateContext, Feature } from "src/states/ApplicationState";
import { GlassCheckbox } from "src/components/MitGlassComponents";
import { JobServiceInterface } from "./JobServiceInterface";
import { Localization, SessionContext } from "@viamap/viamap2-common";

interface SubFormEntry { name: string, value: string };

function SubForm(props: { label: string, type?: string, pattern?: string, subFormData: SubFormEntry[], setSubFormData: (value: SubFormEntry[]) => void }) {

  useEffect(() => {
    console.log("Subform data", props.subFormData)
  }, [props.subFormData]);

  const addSubFormEntry = () => {
    props.setSubFormData([...props.subFormData, { name: '', value: '' }]);
  };

  const removeSubFormEntry = (index: number) => {
    const updatedSubforms = [...props.subFormData];
    updatedSubforms.splice(index, 1);
    props.setSubFormData(updatedSubforms);
  };

  const handleSubFormChange = (
    index: number,
    field: string,
    event: React.ChangeEvent<any>
  ) => {
    const { value } = event.target;
    const updatedSubforms = props.subFormData.map((item, idx) => {
      return idx === index ? field === "name" ?
        { name: value, value: item.value } : { name: item.name, value: value } : item;
    });
    props.setSubFormData(updatedSubforms);
  };

  return (
    <>
      <GlassInputGroupEscape >
        {props.subFormData.map((subform, index) => (
          <div key={index} className="GlassInputField" style={{ marginBottom: "5px" }} >
            <GlassInputControl>
              <input
                type={props.type || "text"}
                pattern={props.pattern}
                value={subform.name}
                onChange={(e) => handleSubFormChange(index, "name", e)}
                placeholder={props.label}
                autoComplete="off" />
              <select
                style={{ flex: "auto 1 0" }}
                name="product"
                value={subform.value || ""}
                onChange={(e) => handleSubFormChange(index, "value", e)}
              >
                {subform.value == "" && <option value="">{Localization.getText("Select Access")}</option>}
                {[JobTypeUserAccessRights.Read, JobTypeUserAccessRights.Write, JobTypeUserAccessRights.Admin].map((product: string) => {
                  return (
                    <option key={product} value={product}>{product}</option>
                  )
                })}
              </select>
            </GlassInputControl>
            <div className="Setting_Butto" title={Localization.getText("Delete Entry")} >
              <BsXLg className="sm" onClick={() => removeSubFormEntry(index)} />
            </div>
          </div>
        ))}
        <GlassButton style={{ marginLeft: "auto" }} onClick={addSubFormEntry}>
          {Localization.getText("Add Entry")}
        </GlassButton >
      </GlassInputGroupEscape>
    </>
  );
};

function InputFormWithSubForm(props: { value: JobType, onChange: (project: JobType) => void, onClose: () => void }) {
  const { hasAccessToFeature } = React.useContext(ApplicationStateContext);
  const [data, setData] = useState<JobType>(props.value);
  const [typesOnServer, setTypesOnServer] = useState<{ id: string, name: string }[]>([]);
  const { state: sessionState } = useContext(SessionContext);

  useEffect(() => {
    let jobInterface = new JobServiceInterface({
      userRef: sessionState.userRef,
      userName: sessionState.userName,
      organizationId: sessionState.customerRef,
      languageCode: sessionState.languageCode as "da" | "en"
    });
    jobInterface.JobListing().then((jobTypes) => {
      setTypesOnServer(jobTypes.map((a) => { return { id: a, name: a } }));
    })
      .catch((error) => {
        console.log("Got error " + error);
      })
  }, []);

  function onchange() {
    props.onChange(data);
  }

  const handleInputChange = (
    key: keyof JobType, value
  ) => {
    setData((prevData) => ({ ...prevData, [key]: value }));
  };

  function transformData(data: Record<string, string[]>): SubFormEntry[] {
    return data ? Object.keys(data).map((key) => {
      return data[key]?.map?.((a) => {
        return { name: key, value: a }
      }) || [{ name: key, value: "" }]
    }).flat() : []
  }

  const SelectJobType = (props: { prompt: string, value: string | undefined, options: { id: string, name: string }[], onSelect: (value: string) => void }) => {
    return (
      <>
        <div className="GlassInputControl BnboProjectSelect" >
          <select onChange={e => {
            let id = e.target.value;
            props.onSelect(id);
          }}
            className="glassInput"
            style={{ width: "auto" }}
            value={props.value}>
            {props.value ? <></> : <option key={"default"} value={""} >{props.prompt}</option>}
            {props.options.toSorted((a, b) => (a.name || "").localeCompare(b.name || "")).map((p: any) => {
              return (
                <option key={p.id} value={p.id}>{p.name}</option>
              );
            })}
          </select>
        </div>
      </>
    )
  }

  return (
    <>
      <ADModalBody>
        <GlassInputGroup onSubmit={() => onchange()} onEscape={props.onClose}>
          <GlassTextInputTransformer label={Localization.getText("Job Type Id")}>
            <input type="text" value={data.id} onChange={(e) => handleInputChange("id", e.target.value)} />
          </GlassTextInputTransformer>
          <GlassTextInputTransformer label={Localization.getText("Job Type Name")}>
            <input type="text" value={data.name} onChange={(e) => handleInputChange("name", e.target.value)} />
          </GlassTextInputTransformer>
          <GlassTextInputTransformer label={Localization.getText("Job Type Description")}>
            <GlassInputControl>
              <textarea value={data.description} onChange={(e) => handleInputChange("description", e.target.value)} />
            </GlassInputControl>
          </GlassTextInputTransformer>
          <GlassTextInputTransformer label={Localization.getText("Server Job Type")} >
            <SelectJobType prompt={Localization.getText("Select Server Job Type")} value={data.serverTypeName} options={typesOnServer} onSelect={(id) => {
              handleInputChange("serverTypeName", id)
            }} />
          </GlassTextInputTransformer>
          <GlassTextInputTransformer label={Localization.getText("Protected")}>
            <GlassCheckbox disabled={!hasAccessToFeature(Feature.JobModuleGlobalAdmin)} checked={data.protected} onClick={(e, val) => handleInputChange("protected", val)} ></GlassCheckbox>
            {!hasAccessToFeature(Feature.JobModuleGlobalAdmin) ? (<div style={{ marginLeft: "5pt", fontSize: "0.8em", color: "grey" }}>
              (Must be Global Admin to change)
            </div>) : null}
          </GlassTextInputTransformer>
          <GlassInputGroupTitle>{Localization.getText("Access Rights")}</GlassInputGroupTitle>
          <GlassTextInputTransformer label={Localization.getText("User Access Rights")}>
            <SubForm
              type="email"
              label={Localization.getText("Email")}
              subFormData={transformData(data.allowedUsersWithRoles)}
              setSubFormData={(value: SubFormEntry[]) => {
                let resData = {}
                value.forEach((entry) => {
                  if (resData[entry.name]) {
                    resData[entry.name].push(entry.value)
                  }
                  else {
                    resData[entry.name] = [entry.value]
                  }
                })
                setData((prevData) => ({ ...prevData, allowedUsersWithRoles: resData }));
              }}
            />
          </GlassTextInputTransformer>
          <GlassTextInputTransformer label={Localization.getText("Organization Access Rights")}>
            <SubForm
              type="text"
              label={Localization.getText("Domain")}
              pattern=".*\w{1-3}"
              subFormData={transformData(data.allowedOrganizationsWithRoles)}
              setSubFormData={(value: SubFormEntry[]) => {
                let resData = {}
                value.forEach((entry) => {
                  if (resData[entry.name]) {
                    resData[entry.name].push(entry.value)
                  }
                  else {
                    resData[entry.name] = [entry.value]
                  }
                })
                setData((prevData) => ({ ...prevData, allowedOrganizationsWithRoles: resData }));
              }}
            />
          </GlassTextInputTransformer>
        </GlassInputGroup>
      </ADModalBody>
      <ADModalFooter>
        <GlassButton onClick={() => onchange()}>
          {Localization.getText("Submit")}
        </GlassButton>
        <GlassButton onClick={props.onClose}>
          {Localization.getText("Close")}
        </GlassButton>
      </ADModalFooter>
    </>
  );
};

// export default InputFormWithSubForm;

export const JobInstiantiationTypeEditor = (props: {
  title?: string,
  show: boolean,
  value: JobType,
  onClose: () => void,
  onChange: (project: JobType) => void
}) => {

  if (!props.show) {
    return <></>
  }

  return (
    <Fragment key={props.value.id}>
      <AdvancedDragModal title={props.title ?? "Job Type Editor"} PosDefault={{ width: "650px", left: "50%", transform: "translateX(-50%)", top: "100px" }} onClose={() => props.onClose()}>
        <InputFormWithSubForm value={props.value} onChange={(e) => props.onChange(e)} onClose={() => props.onClose()} />
      </AdvancedDragModal>
    </Fragment>
  )
}